import { ZodError, z } from 'zod';

const envSchema = z.object({
  DEV: z.boolean(),
  VITE_BACKEND_URL: z.url(),
  VITE_CLIENT_URL: z.url(),
  VITE_SONDA: z.boolean().optional(),
});

export type SafeEnv = z.infer<typeof envSchema>;

let safeEnv: SafeEnv;

try {
  safeEnv = envSchema.parse(import.meta.env);
} catch (error) {
  if (error instanceof ZodError) {
    throw new Error('Invalid environment variables');
  }
}

export { safeEnv };
